import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActionType } from '@models/widget/action-type.enum';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { CompanyService } from '@services/my-insurance/company.service';
import{ NavigationService } from '@services/navigation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule],
  selector: 'app-faq-home',
  templateUrl: './faq-home.component.html',
  styleUrls: ['./faq-home.component.scss'],
})
export class FaqHomeComponent implements OnInit {
  existLegacyPolicy: boolean;
  showCompany: string;
  constructor(
    private policyDataService: PolicyDataService,
    private companyService: CompanyService,
    private navService: NavigationService
  ) {
    this.existLegacyPolicy = false;
  }

  ngOnInit() {
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    })
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
          this.existLegacyPolicy = policyResponse.some(policy => 
            policy.company?.companyName === "ACIC" || policy.company?.companyName === "TW")
      }
    });
    this.navService.saveCurrentAction(ActionType.ExploreFAQs);
  }
}
